import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import KeyValue, { Row } from '@shell/components/Resource/Detail/Metadata/KeyValue.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';

export type Annotation = Row;

export interface AnnotationsProps {
  annotations: Annotation[];

  onShowConfiguration?: (returnFocusSelector: string, defaultTab: string) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    annotations: {},
    onShowConfiguration: { type: Function }
  },
  emits: ['show-configuration'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const store = useStore();
const i18n = useI18n(store);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(KeyValue, {
    propertyName: _unref(i18n).t('component.resource.detail.metadata.annotations.title'),
    rows: __props.annotations,
    type: "active",
    onShowConfiguration: _cache[0] || (_cache[0] = (returnFocusSelector) => emit('show-configuration', returnFocusSelector, 'labels-and-annotations'))
  }, null, 8, ["propertyName", "rows"]))
}
}

})